import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-image-container',
  templateUrl: './image-container.component.html',
  styleUrls: ['./image-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImageContainerComponent implements OnInit {
  imageLoaded = false;

  @Input() image: string;

  @Input() type: 'product' | 'small-product' | 'program' | 'category' | 'brand';

  @Input() featured = false;

  @Input() recommended = false;

  @Input() isCancelled = false;

  @Input() priorityItem = false;

  constructor() {}

  ngOnInit(): void {}

  get backgroundStyle() {
    const imagePath = this.imageLoaded
      ? this.image
      : '/assets/img/app/no-image.png';
    return {
      'background-image': `url(${imagePath})`,
    };
  }

  get imageClass(): string {
    let featuredClass = '';

    if (this.featured || this.recommended || this.priorityItem) {
      const position =
        this.type === 'product' ? 'featured-bottom' : 'featured-top';
      featuredClass = `with-featured ${position}`;
    }
    return `${this.type}--image ${featuredClass}`;
  }

  onImageLoad() {
    this.imageLoaded = true;
  }
}
